import { useContext } from 'react';
import { CompaniesContext, CompaniesContextData } from './context';

export function useCompanies(): CompaniesContextData {
    const data = useContext<CompaniesContextData | undefined>(CompaniesContext);

    if (!data) {
        throw new Error(
            "CompaniesContext unavailable. Are you sure you're using this in a nested component of an CompaniesContextProvider?"
        );
    }

    return data;
}
